<template>
  <BOverlay
    :show="loading"
    spinner-variant="primary"
    variant="light"
    blur="0"
    opacity=".5"
    rounded="sm"
  >
    <div
      :id="id"
      ref="tableContainer"
      class="overflow-y-auto max-h-[550px]"
    >
      <b-table-simple class="w-full table-auto">
        <b-thead class="!sticky !top-0 !z-10 bg-[#F4F4F4]">
          <b-tr>
            <b-th class="align-middle !border-none !rounded-tl-md text-[#626262] text-[13px] font-semibold py-[12px] px-[16px] !min-w-[200px]">
              Waktu Pembuatan
            </b-th>
            <b-th class="align-middle !border-none text-[#626262] text-[13px] font-semibold py-[12px] px-[16px]">
              Nama Akun
            </b-th>
            <b-th class="align-middle !border-none text-[#626262] text-[13px] font-semibold py-[12px] px-[16px]">
              ID Ad Account
            </b-th>
            <b-th class="align-middle !border-none text-[#626262] text-[13px] font-semibold py-[12px] px-[16px]">
              Jenis Akun
            </b-th>
            <b-th class="align-middle !border-none text-[#626262] text-[13px] font-semibold py-[12px] px-[16px] !min-w-[200px]">
              Estimasi Saldo
            </b-th>
            <b-th class="align-middle !border-none !rounded-tr-md text-[#626262] text-[13px] font-semibold py-[12px] px-[16px]">
              Status
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody class="divide-y divide-[#F0F0F0]">
          <b-tr
            v-if="!items || items.length === 0"
          >
            <b-td
              colspan="6"
              class="text-center !py-[2.5rem] text-[#828282] text-[14px]"
            >
              Tidak ada data yang ditampilkan
            </b-td>
          </b-tr>
          <b-tr
            v-for="(item, index) in items"
            :key="index"
            class="hover:bg-[#FDFDFD]"
          >
            <!-- Waktu Pembuatan -->
            <b-td class="align-middle py-[14px] px-[16px]">
              <p class="text-[#333333] text-[13px] font-medium">
                {{ item.created_at ? formatDate(item.created_at) : '' }}
              </p>
              <span class="text-[#828282] text-[12px]">
                {{ item.created_at ? formatTime(item.created_at) : '' }}
              </span>
            </b-td>

            <!-- Nama Akun -->
            <b-td class="align-middle py-[14px] px-[16px]">
              <p class="text-[#333333] text-[13px] font-medium">
                {{ item.account_name || '-' }}
              </p>
              <span class="text-[#828282] text-[12px]">
                {{ item.partner_email || '-' }}
              </span>
            </b-td>

            <!-- ID Ad Account -->
            <b-td class="align-middle py-[14px] px-[16px]">
              <p class="text-[#333333] text-[13px]">
                {{ item.ad_account_id || '-' }}
              </p>
            </b-td>

            <!-- Jenis Akun -->
            <b-td class="align-middle py-[14px] px-[16px] !min-w-[200px]">
              <div
                class="inline-flex items-center gap-x-[6px] rounded-md px-[10px] py-[4px] text-[12px] font-medium"
                :class="getAdAccountType(item).classNames"
              >
                <img
                  v-if="getAdAccountType(item).linkIcon"
                  :src="getAdAccountType(item).linkIcon"
                  alt="Icon"
                  class="w-[16px] h-[16px]"
                >
                <span class="whitespace-nowrap">{{ getAdAccountType(item).text }}</span>
              </div>
            </b-td>

            <!-- Estimasi Saldo -->
            <b-td class="align-middle py-[14px] px-[16px] !min-w-[150px]">
              <p class="text-[#333333] text-[13px] font-medium">
                {{ IDR(item.estimated_balance || 0) }}
              </p>
            </b-td>

            <!-- Status -->
            <b-td class="align-middle py-[14px] px-[16px]">
              <span
                class="inline-block px-[14px] py-[4px] rounded-full text-[12px] font-medium capitalize"
                :class="getStatusBadge(item.account_status).classNames"
              >
                {{ getStatusBadge(item.account_status).text }}
              </span>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <div
        id="detail-bm-list-sentinel"
        ref="scrollSentinel"
        class="h-[1px] w-full"
      />
    </div>
  </BOverlay>
</template>

<script>
import { IDR } from '@/libs/currency'
import { DDMMMMYYYY, TIME } from '@/libs/filterDate'

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      adAccountTypes: {
        whitelist: {
          classNames: 'bg-[#BEE6FC] text-[#0F679A]',
          text: 'Meta Whitelist',
          linkIcon: 'https://storage.googleapis.com/komerce/komads-meta/meta.svg',
        },
        cpas_shopee: {
          classNames: 'bg-[#FFECE9] text-[#F95031]',
          text: 'CPAS Shopee',
          linkIcon: 'https://storage.googleapis.com/komerce/komads-meta/shopee.svg',
        },
        cpas_tokopedia: {
          classNames: 'bg-[#DCF3EB] text-[#10673E]',
          text: 'CPAS Tokopedia',
          linkIcon: 'https://storage.googleapis.com/komerce/komads-meta/tokopedia.svg',
        },
      },
      statusBadges: {
        active: { classNames: 'bg-[#DCF3EB] text-[#10673E]', text: 'Active' },
        restricted: { classNames: 'bg-[#FFEDED] text-[#E31A1A]', text: 'Restricted' },
        invalid: { classNames: 'bg-[#F4F4F4] text-[#333333]', text: 'Invalid' },
      },
      IDR,
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '-'
      return DDMMMMYYYY(date)
    },
    formatTime(date) {
      if (!date) return ''
      return `${TIME(date)} WIB`
    },
    getAdAccountType(item) {
      const type = item?.ad_account_type !== 'whitelist' && item?.marketplace ? `${item.ad_account_type.toLowerCase()}_${item.marketplace.toLowerCase()}` : 'whitelist'
      return this.adAccountTypes[type]
    },
    getStatusBadge(status) {
      const s = status.toLowerCase()
      const badge = this.statusBadges[s]
      if (badge) {
        return badge
      }
      return {
        classNames: '',
        text: '',
      }
    },
  },
}
</script>

<style scoped>
p {
  margin: 0;
}
</style>
